// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.WalletClientProvisionedDocument
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.wallet.client.WalletClientProvisionedDocumentOpenID4VCI

fun WalletClientProvisionedDocument.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "wwawse3OMszQFNbFs6W7L_fm5SOQ7-3ZneCIUczmwmY")
val WalletClientProvisionedDocument_cborSchemaId = ByteString(-61, 6, -80, -79, -19, -50, 50, -52, -48, 20, -42, -59, -77, -91, -69, 47, -9, -26, -27, 35, -112, -17, -19, -39, -99, -32, -120, 81, -52, -26, -62, 102)

fun WalletClientProvisionedDocument.Companion.fromCbor(data: ByteArray): WalletClientProvisionedDocument {
    return WalletClientProvisionedDocument.fromDataItem(Cbor.decode(data))
}

val WalletClientProvisionedDocument.Companion.cborSchemaId: ByteString
    get() = WalletClientProvisionedDocument_cborSchemaId

fun WalletClientProvisionedDocument.toDataItem(): DataItem {
    return when (this) {
        is WalletClientProvisionedDocumentOpenID4VCI -> (this as WalletClientProvisionedDocumentOpenID4VCI).toDataItem()
    }
}

fun WalletClientProvisionedDocument.Companion.fromDataItem(dataItem: DataItem): WalletClientProvisionedDocument {
    val type = dataItem["type"].asTstr
    return when (type) {
        "OpenID4VCI" -> WalletClientProvisionedDocumentOpenID4VCI_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
